import type {ReactNode} from "react";
import {AdminPageHeader, type AdminBreadcrumbItem} from "./AdminPageHeader";

type Props = {
  title?: string;
  description?: string;
  breadcrumbs?: AdminBreadcrumbItem[];
  actions?: ReactNode;
  children: ReactNode;
  hideHeader?: boolean;
};

export function AdminPageLayout({
  title,
  description,
  breadcrumbs,
  actions,
  children,
  hideHeader
}: Props) {
  return (
    <div className="admin-page">
      {!hideHeader && title ? (
        <AdminPageHeader
          title={title}
          description={description}
          breadcrumbs={breadcrumbs}
          actions={actions}
        />
      ) : null}
      {children}
    </div>
  );
}
